import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";

import {
  deleteSuperAdmin,
  resetSuperAdminStatus,
  getSuperadminList,
} from "../../../redux/actions";
import { STATUS } from "../../../redux/constants";
import CeroSideSheetDrawer from "../../../components/CeroSideSheetDrawer";
import useStyles from "./styles";

const SuperAdminDeletePrompt = (props) => {
  const { setOpenDeletePrompt, adminUser, isOpen } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const deleteStatus = useSelector(
    (state) => state.superAdmin.deleteSuperAdmin
  );

  useEffect(() => {
    if (deleteStatus.status === STATUS.SUCCESS) {
      enqueueSnackbar("Super Admin deleted successfully", {
        variant: "success",
      });
      setOpenDeletePrompt(false);
      dispatch(resetSuperAdminStatus());
      dispatch(getSuperadminList());
    } else if (deleteStatus.status === STATUS.ERROR) {
      enqueueSnackbar("Super Admin delete failed", { variant: "error" });
    }
  }, [deleteStatus, dispatch, enqueueSnackbar, setOpenDeletePrompt]);

  const handleDeleteFacility = () => {
    dispatch(deleteSuperAdmin(adminUser?.id));
  };

  const getPrimaryConfirmDrawer = () => {
    return (
      <Box className={classes.mainContainer}>
        <Typography variant="span">Are you sure you want to delete</Typography>
        <Box
          fontWeight="fontWeightMedium"
          display="inline"
        >{` ${adminUser?.name}?`}</Box>
      </Box>
    );
  };

  return (
    <CeroSideSheetDrawer
      primaryDrawer={{
        drawerOpen: isOpen,
        onClose: () => setOpenDeletePrompt(false),
        content: getPrimaryConfirmDrawer(),
        header: { title: "Confirm!" },
        classes: {
          drawerContainer: classes.drawerContainer,
          contentArea: classes.drawerContentArea,
        },
        footer: {
          primaryBtnTitle: "Confirm",
          secondaryBtnTitle: "Cancel",
          hideSecondaryBtn: false,
          primaryBtnAction: handleDeleteFacility,
          secondaryBtnAction: () => setOpenDeletePrompt(false),
        },
      }}
    />
  );
};
export default SuperAdminDeletePrompt;
